import React from "react";
import { CheckBox, Grommet } from "grommet";
export var SquareCheckBox = function SquareCheckBox(_ref) {
  var disabled = _ref.disabled,
    checked = _ref.checked,
    onChange = _ref.onChange,
    label = _ref.label,
    icon = _ref.icon;
  var theme = {
    global: {
      colors: {
        brand: "#315FB6",
        "site-colors-1": "#F8F8F8",
        "site-colors-2": "#E8EAEC",
        "site-colors-3": "#EDEFF2",
        "site-colors-4": "#D0DAE8",
        "dark-site-color": "#1A1A1A",
        grey: "#D1D4D8",
        "dark-blue": "#333F51",
        black: "#000000",
        white: "#ffffff",
        text: {
          light: "#333333",
          dark: "#ffffff",
        },
        focus: "transparent",
      },
    },
    checkBox: {
      border: {
        width: "1px",
        color: "black",
        radius: "4px",
      },
      gap: "xsmall",
      size: "24px",
      icon: {
        size: "20px",
        extend: "stroke: black;",
      },
      icons: {
        checked: icon,
      },
      extend: "\n        color: 'black';\n      ",
    },
  };
  return /*#__PURE__*/ React.createElement(
    Grommet,
    {
      theme: theme,
    },
    /*#__PURE__*/ React.createElement(CheckBox, {
      disabled: disabled,
      checked: checked,
      onChange: onChange,
      label: label,
    })
  );
};
